function MintedProject({ image, ic,isShowTitle ,isFromAll}) {
    return (
        <div className="w-full h-full  rounded-md overflow-hidden  relative">
            <img className="w-full h-full object-cover   " src={image} alt="claimed-card" />
        {isShowTitle &&  <p className={`absolute  ${isFromAll ?"top-[2.6rem] left-[.8rem] text-xs " : "top-[3.2rem] left-[1.5225rem] text-base"}  text-white font-semibold `} >{ic?.project?.title}</p>}
            {/* {ic?.blockchain?.image && (
                <img
                    className="absolute w-5 h-5 rounded-full bottom-[.625rem] right-[.625rem]"
                    src={ic?.blockchain?.image}
                    alt={ic?.blockchain?.name}
                />
            )} */}
        </div>
    );
}

export default MintedProject;
